import { UserService } from "@/app/core/apis/user.service";
import { IntercomSessionService } from "@/app/core/services/intercom-session.service";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import posthog from "posthog-js";
import { EMPTY, of } from "rxjs";
import { catchError, map, switchMap, tap, withLatestFrom } from "rxjs/operators";
import {
  loadBusinessDetail,
  loadBusinessDetailSuccess,
  loadCurrentUser,
  loadCurrentUserFailure,
  loadCurrentUserSuccess,
  selectBusiness,
} from "./auth.actions";
import { selectorBusinessDetail, selectorCurrentUser } from "./auth.selectors";

@Injectable()
export class AuthEffects {
  constructor(
    private actions$: Actions,
    private userService: UserService,
    private intercomSession: IntercomSessionService,
    private store: Store
  ) {}

  currentUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCurrentUser),
      switchMap(() =>
        this.userService.me().pipe(
          tap((user) => posthog.identify(user.id, { email: user.email, name: `${user.firstName} ${user.lastName}` })),
          map((user) => loadCurrentUserSuccess({ user })),
          catchError((error) => of(loadCurrentUserFailure({ error })))
        )
      )
    )
  );

  businessDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBusinessDetail),
      switchMap(({ businessId }) => this.userService.getBusinessDetail(businessId).pipe(map((business) => loadBusinessDetailSuccess({ business }))))
    )
  );

  bootIntercom$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadCurrentUserSuccess, selectBusiness, loadBusinessDetailSuccess),
        withLatestFrom(this.store.select(selectorCurrentUser), this.store.select(selectorBusinessDetail)),
        switchMap(([action, user, business]) => {
          if (!user) {
            return EMPTY;
          }
          const selected =
            action.type === selectBusiness.type || action.type === loadBusinessDetailSuccess.type ? action.business : business;
          return this.intercomSession.boot(user, {
            businessId: selected?.id,
            flow: selected?.caseWorkflowEnabled ? "casetrust" : "standard",
          });
        })
      ),
    { dispatch: false }
  );
}
